module.exports = __webpack_public_path__ + "img/TREASURY.d6033d6c.svg";